export default __webpack_public_path__ + "static/media/hero.5797a5cf.svg";